module.exports = __webpack_public_path__ + "inistate-logo-full-transparent.png?cca1e47b4beb8aeab418157dd90d28b6";